import Icon from '@mui/material/Icon';
import { Stack } from '@mui/joy';
import { Typography } from '@mui/material';
import { useContext, useEffect, useState } from 'react';
import { FetchedDataContext } from './Context';



function Info({props}) { 

    return(

        <Stack 
            direction={"row"}
            spacing={2} 
            sx={{
                display: props.display ? "flex" : 'none',
                justifyContent: "center",
                border: "2px dashed",
                borderColor: "divider",
                borderRadius: "5px",
                p:1, 
                marginBottom: 4, 
                width: "fit-content", 
                mx: "auto"
                }}>
                <Icon
                    
                    sx={{
                    color: props.icon_color,
                    fontSize: props.icon_size,
                    }}>
                    {props.icon}
                </Icon>
                <Typography fontSize={props.text_font_size} color={props.text_color} fontWeight={props.text_weight}>
                    {props.text}
                </Typography>
            
        </Stack>
        
    )
};

export default function DynamicInfoAlert() {

    const fetchedData = useContext(FetchedDataContext)
    const fetchDisplayInfo = fetchedData.get("fetchDisplayInfo")

    return(
        fetchDisplayInfo?.map((info,index) => 

           ( <Info key={index} props={info} />)
    )
)
    
};